import React, { useState } from "react";
import "../Dropdown/Dropdown.css";
import { useRef, useEffect, useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { useTranslationContext } from "../../contexts/TranslationContext";

const Dropdown = ({
  label = "Select",
  items = [],
  selectedItem,
  setSelectedItem,
  icon,
  showArrow = false,
  arrowIcon,
  showIcon = true,
  showClear = false,
  shouldShowButtonBackground = false,
}) => {
  const dropdownRef = useRef(null);
  const { isDarkMode } = useContext(ThemeContext);
  const { translations } = useTranslationContext();
  const clearText = translations["clear"] || "Clear";
  const noDataText = translations["no_data"] || "No data available";
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropDownOpen((prevState) => !prevState)
  };

  const handleClear = () => {
    setIsDropDownOpen(false);
    setSelectedItem("");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropDownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropDownOpen]);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
        <button
          className={`button-style dropdown-selector ${shouldShowButtonBackground
              ? isDarkMode
                ? "dark-mode"
                : "light-mode"
              : ""
            }`}
          onClick={toggleDropdown}
        >
          {showIcon && icon && (
            <img src={icon} alt={`${label} icon`} className="dropdown-logo" />
          )}
          <span className={`dropdown-text ${isDarkMode ? "dark-mode" : "light-mode"}`}>{selectedItem}</span>
          {showArrow && arrowIcon && (
            <img
              src={arrowIcon}
              alt="dropdown-arrow"
              className={`dropdown-arrow ${isDropDownOpen ? "rotate" : ""}`}
            />
          )}
        </button>
        {isDropDownOpen && (
          <div className={`dropdown-menu dropdown-options ${isDarkMode ? "dark-mode" : "light-mode"}`}>
            <div
              className={`dropdown-heading-wrapper ${isDarkMode ? "dark-mode" : "light-mode"
                }`}
            >
              <span className={`dropdown-heading ${isDarkMode ? "dark-mode" : "light-mode"
                }`}>{label}</span>
              {showClear && selectedItem && (
                <button
                  className="dropdown-clear fs-14 fw-medium button-style"
                  onClick={handleClear}
                >
                  {clearText}
                </button>
              )}
            </div>
            {items.length === 0 ? (
              <div className="no-data">{noDataText}</div>
            ) : (
              items.map((item) => (
                <div
                  key={item}
                  className={`dropdown-item ${selectedItem === item
                    ? isDarkMode
                      ? "selected-dark"
                      : "selected-light"
                    : isDarkMode
                      ? "dark-mode"
                      : "light-mode"
                    }`}
                  onClick={() => {
                    setSelectedItem(item);
                    setIsDropDownOpen(false);
                  }}
                >
                  {item}
                  {selectedItem === item && <span className="checkmark">✓</span>}
                </div>
              ))
            )}
          </div>
        )}
    </div>
  );
};

export default Dropdown;
